// extracted by mini-css-extract-plugin
export default {"empty":"empty_empty__i-tG+","icon":"empty_icon__Bltkf"};